import React, { useState, useEffect, Fragment } from 'react'
import { Modal, Button, Row, Col, Image } from 'react-bootstrap'
import callApi from '../../helpers/callapi'
import { banks } from '../../constants/constants'
import ModalEditDetail from './ModalEditDetail'
const ModalDetail = (props) => {
  const { showModalDetail, setShowModalDetail, agentId, fetchAgents } = props
  const [loading, setLoading] = useState(false)
  const [agent, setAgent] = useState()
  const [showEditDetail, setShowEditDetail] = useState(false)

  let dataAgent = []
  let dataAgent2 = []
  useEffect(() => {
    if (showModalDetail) {
      fetchAgentDetail()
    }
  }, [showModalDetail])

  const fetchAgentDetail = async () => {
    try {
      setLoading(true)
      const _agent = await callApi({
        url: `/agents/${agentId}`,
      })

      setAgent(_agent)
      setLoading(false)
    } catch (error) {
      setAgent([])
      setLoading(false)
    }
  }

  if (agent) {
    dataAgent = []
    dataAgent2 = []
    dataAgent = [
      { title: 'รหัส:', value: agent.agentId },
      {
        title: 'ชื่อ - นามสกุล:',
        value: `${agent.firstName} ${agent.lastName}`,
      },
      { title: 'ธนาคาร:', value: banks[agent.bankName] },
      { title: 'เลขที่บัญชี:', value: agent.bankAccount },
      { title: 'ค่าคอมตัวแทน:', value: agent.commission },
      { title: 'ค่าคอมหัวหน้าตัวแทน:', value: '' },
    ]
    //----------------------------------------------//
    dataAgent2 = [
      {
        title: 'เงินคงเหลือ:',
        value: agent.remainingMoney.toFixed(2) + ' บาท',
      },
      { title: 'รายได้ทั้งหมด:', value: agent.totalMoney.toFixed(2) + ' บาท' },
      { title: 'จำนวนลูกค้า:', value: agent.customerCount.toFixed(2) },
    ]
  }

  return (
    <Fragment>
      {agent && (
        <Modal className="fade" show={showModalDetail} size="xxl">
          <Modal.Header>
            <Modal.Title>
              คุณ {agent.firstName} {agent.lastName}
            </Modal.Title>
            <Button variant="" className="close" onClick={() => setShowModalDetail(false)}>
              <span>&times;</span>
            </Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col className="text-center">
                <Image src={agent.displayImage} rounded width="200" height="195" />
              </Col>
              <Col>
                {dataAgent.map((item, i) => {
                  if (item.value) {
                    return (
                      <p key={i}>
                        <b>{item.title}</b> <span>{item.value}</span>
                      </p>
                    )
                  }
                })}
              </Col>
              <Col>
                {dataAgent2.map((item, i) => {
                  return (
                    <p key={i}>
                      <b>{item.title}</b> <span>{item.value}</span>
                    </p>
                  )
                })}
              </Col>
              <Col className="text-right">
                <Button
                  className="mr-2"
                  variant="outline-primary btn-rounded"
                  style={{ cursor: 'pointer' }}
                  onClick={() => setShowEditDetail(true)}
                >
                  แก้ไขข้อมูล
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      )}
      {agent && (
        <ModalEditDetail
          showEditDetail={showEditDetail}
          setShowEditDetail={setShowEditDetail}
          targetAgent={agent}
          onClose={() => fetchAgentDetail()}
          // onClose={() => fetchAgentDetail(currentPage)}
          fetchAgents={fetchAgents}
        />
      )}
    </Fragment>
  )
}
export default ModalDetail
